import {
  FormControl,
  TextField,
  styled,
} from "@mui/material";

const StyledFormControl = styled(FormControl)(() => ({
  minWidth: 120,
  // marginBottom: "16px",
  "& .MuiInputLabel-root": {
    fontSize: "14px",
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    backgroundColor: "#fff",
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
    },
  },
  "& .MuiInputLabel-root": {
    color: "#666",
    "&.Mui-focused": {
      color: theme.palette.primary.main,
    },
  },
}));

interface QuestionTextInputProps {
  questionNumber: number;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onFocus: (questionNumber: number) => void;
}

function QuestionTextInput({ 
  questionNumber, 
  value, 
  onChange,
  placeholder = "Enter your answer",
  onFocus
}: QuestionTextInputProps) {

  return (
    <StyledFormControl fullWidth onFocus={() => onFocus(questionNumber)}>
      <StyledTextField
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        variant="outlined"
        label="Enter Answer"
        aria-label={`Answer for Question ${questionNumber}`}
      />
    </StyledFormControl>
  );
}

export default QuestionTextInput;
